module.exports = __webpack_public_path__ + "img/img_logo_sm.dc01a459.svg";